import React from 'react';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import ReactDOM from 'react-dom/client';
import { Auth0Provider } from '@auth0/auth0-react'

import './index.css';
import Layout from "./Layout.js";
import ErrorPage from "./ErrorPage.js"
import NotFound from "./NotFound.js"
import Home from './Home.js'
import ContactUs from './ContactUs.js'
import Tools from './tools/Tools.js'
import Blog from './blog/Blog.js'
import Post from './blog/Post.js'
//import reportWebVitals from './reportWebVitals';
import links from './nav.js'

const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: '/',
        element: <Home />
      },
      {
        path: '/tools',
        element: <Tools />
      },
      {
        path: '/blog',
        element: <Blog />
      },
      {
        path: '/blog/:tag',
        element: <Post />
      },
      {
        path: '/contact',
        element: <ContactUs />
      },
      ...links.map(link => ({
        path: link.url,
        element: link.element
      })),
      ...links.map(link => ({
        path: `${link.url}/:id`,
        element: link.element
      })),
      {
        path: "*",
        element: <NotFound />
      }
    ],
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Auth0Provider
      domain="dev-f0as8l0dh5rc8lfa.us.auth0.com"
      clientId="KG2G0RtIiPsu981xjnnKAZ3gpcVD75B5"
      audience="https://dev-f0as8l0dh5rc8lfa.us.auth0.com/api/v2/"
      useRefreshTokens={true}
      cacheLocation="localstorage"
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: 'https://dev-f0as8l0dh5rc8lfa.us.auth0.com/api/v2/',
      }}
    >
      <RouterProvider router={router} />
    </Auth0Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
